import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { MessageCircle } from "lucide-react";

export function WhatsAppButton() {
  const { data: settings } = useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await api.get("/settings")).data,
  });
  const number = (settings?.whatsapp_number || "").replace(/[^0-9]/g, "");
  if (!number) return null;
  const href = `https://wa.me/${number}?text=${encodeURIComponent("Hi Saad IPTV, I'd like to know more about your packages.")}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-[0_0_24px_rgba(37,211,102,0.5)] hover:scale-110 transition-transform duration-300"
      aria-label="Contact on WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-white" fill="white" />
    </a>
  );
}
